import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	EOGRE_PROFILE_FILTER_EVENT,
	EOGRE_PROFILE_FOCUS_EVENT,
	EOGRE_PROFILE_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.eogre_profiles']);

/**
 * Open the EoGRE accordion on the Templates page.
 *
 * Event-based rather than a DOM click, the way the SSID Template and
 * SSID Schedule sections on this page already are: the page owns which
 * accordion is expanded, and it scrolls the panel into view before it
 * reports back. Retried until the page mounts, so arriving here from
 * another route works as well as already standing on it.
 *
 * @return {Promise<void>} completion acknowledgement
 */
export function openEoGREProfileSection() {
	return openResourceSection(
		EOGRE_PROFILE_SECTION_EVENT,
		'profile.eogre_profiles',
		SECTIONS,
	);
}

/**
 * Filter the EoGRE profile table to a search term.
 *
 * The table asks Canvas for the matching page rather than filtering the
 * rows it happens to be showing, so a profile on any page is findable.
 *
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyEoGREProfileFilter(query) {
	return dispatchAcknowledgedEvent(EOGRE_PROFILE_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'eogre_profile',
	});
}

/**
 * Point at one EoGRE profile's row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusEoGREProfile(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_eogre_profile_focus'));
	return dispatchAcknowledgedEvent(EOGRE_PROFILE_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'eogre_profile',
	});
}
